<template lang="pug">
    layout(:page="'auth'")
        template(slot="title")

            // Title
            title-component(:title="$t('auth.confirmEmail.title')" type="h1")

            // Message
            div(v-html="$t('auth.confirmEmail.message')")

        // Login form
        confirm-registration-form(:email="email")
</template>

<script>
    import ConfirmRegistrationForm from './ConfirmRegistrationForm';
    import Layout from '../Layout';
    import Title from '~components/Title';
    import VueTypes from 'vue-types';

    export default {
        components: {
            ConfirmRegistrationForm: ConfirmRegistrationForm,
            Layout,
            TitleComponent: Title
        },
        props: {
            email: VueTypes.string.def('')
        }
    };
</script>
